<div *ngIf="!this.isFirstLoad" class="calendar-screen-container">
    <calendar-layout [config]="layoutConfig">
        <ng-template #refinedBy>
            <calendar-refineby [config]="refinebyConfig" [isEntity]="isEntity"></calendar-refineby>
        </ng-template>
        <ng-template #preview>
            <div class="e-toolbar-container">
                <div [style.visibility]="isShowGrid ? 'visible' : 'hidden'" class="e-items-count">
                    {{getRecord()}}</div>
                <div class="e-actions-container">
                    <smart-icon tid="refresh_icon" name="refresh" (click)="refreshCalendar()" class="light refresh"
                        title="Refresh">
                    </smart-icon>
                    <div class="e-toolbar-menu">
                        <calendar-view-layout [config]="calendarLayoutViewMenuConfig" title="Change View">
                        </calendar-view-layout>
                    </div>
                    <div class="e-toolbar-event">
                        <button tam-button tamType="primary" tamSize="normal" class="dialog-button"
                            (click)="newEvent()">New
                            Event</button>
                    </div>
                </div>
            </div>
            <div *ngIf="!isShowGrid" class="e-schedule-container">
                <ejs-schedule #scheduleObj id="schedule" [eventSettings]="eventSettings"
                    (popupOpen)="onPopupOpen($event)" (eventClick)="onEventClick($event)"
                    (displayedColumnsChanged)="onDisplayedColumnsChanged($event)"
                    (eventRendered)="onEventRendered($event)" (navigating)="onNavigatingEvent($event)"
                    (created)="onCreated($event)" (contextmenu)="onContextMenu($event)"
                    (cellClickEvent)="onCellDoubleClick($event)" (actionBegin)="onActionBegin($event)"
                    (actionComplete)="onActionComplete($event)" (dataBound)="onDataBound()"
                    (dataBinding)="onDataBinding($event)">
                    <e-views>
                        <e-view option='Day'>
                            <ng-template #eventTemplate let-data>
                                <div (dblclick)="onItemDoubleClick($event, data)"
                                    *ngIf="!data.isAllDay && !data.isShowOnTop" (touchstart)="onTouchStart()"
                                    (touchend)="onTouchEnd($event)" class="template-wrap-container">
                                    <div class='template-wrap'>
                                        <div class="subject">{{data.Subject}}</div>
                                        <div class="sidenote-area" *ngIf="data.notesInThread > 1">
                                            <smart-icon name="side-note"></smart-icon>
                                        </div>
                                        <div class="attachment-area" *ngIf="data.attachmentsInThread > 0">
                                            <smart-icon name="attachment"></smart-icon>
                                        </div>
                                    </div>
                                    <div class='template-wrap'>
                                        <div class="entities">{{data.Entities}}</div>
                                    </div>
                                </div>
                                <div (dblclick)="onItemDoubleClick($event, data)"
                                    *ngIf="data.isAllDay || data.isShowOnTop" (touchstart)="onTouchStart()"
                                    (touchend)="onTouchEnd($event)" class="template-wrap-container">
                                    <div class='template-wrap'>
                                        <div class="subject">
                                            {{data.Subject}} ({{data.Entities}})
                                        </div>
                                        <div class="sidenote-area" *ngIf="data.notesInThread > 1">
                                            <smart-icon name="side-note"></smart-icon>
                                        </div>
                                        <div class="attachment-area" *ngIf="data.attachmentsInThread > 0">
                                            <smart-icon name="attachment"></smart-icon>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </e-view>
                        <e-view option='WorkWeek'>
                            <ng-template #eventTemplate let-data>
                                <div (dblclick)="onItemDoubleClick($event, data)"
                                    *ngIf="!data.isAllDay && !data.isShowOnTop" (touchstart)="onTouchStart()"
                                    (touchend)="onTouchEnd($event)" class="template-wrap-container">
                                    <div class='template-wrap'>
                                        <div class="subject">{{data.Subject}}</div>
                                        <div class="sidenote-area" *ngIf="data.notesInThread > 1">
                                            <smart-icon name="side-note"></smart-icon>
                                        </div>
                                        <div class="attachment-area" *ngIf="data.attachmentsInThread > 0">
                                            <smart-icon name="attachment"></smart-icon>
                                        </div>
                                    </div>
                                    <div class='template-wrap'>
                                        <div class="entities">{{data.Entities}}</div>
                                    </div>
                                </div>
                                <div (dblclick)="onItemDoubleClick($event, data)"
                                    *ngIf="data.isAllDay || data.isShowOnTop" (touchstart)="onTouchStart()"
                                    (touchend)="onTouchEnd($event)" class="template-wrap-container">
                                    <div class='template-wrap'>
                                        <div class="subject">{{data.Subject}} ({{data.Entities}})</div>
                                        <div class="sidenote-area" *ngIf="data.notesInThread > 1">
                                            <smart-icon name="side-note"></smart-icon>
                                        </div>
                                        <div class="attachment-area" *ngIf="data.attachmentsInThread > 0">
                                            <smart-icon name="attachment"></smart-icon>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </e-view>
                        <e-view option='Week'>
                            <ng-template #eventTemplate let-data>
                                <div (dblclick)="onItemDoubleClick($event, data)"
                                    *ngIf="!data.isAllDay && !data.isShowOnTop" (touchstart)="onTouchStart()"
                                    (touchend)="onTouchEnd($event)" class="template-wrap-container">
                                    <div class='template-wrap'>
                                        <div class="subject">{{data.Subject}}</div>
                                        <div class="sidenote-area" *ngIf="data.notesInThread > 1">
                                            <smart-icon name="side-note"></smart-icon>
                                        </div>
                                        <div class="attachment-area" *ngIf="data.attachmentsInThread > 0">
                                            <smart-icon name="attachment"></smart-icon>
                                        </div>
                                    </div>
                                    <div class='template-wrap'>
                                        <div class="entities">{{data.Entities}}</div>
                                    </div>
                                </div>
                                <div (dblclick)="onItemDoubleClick($event, data)"
                                    *ngIf="data.isAllDay || data.isShowOnTop" (touchstart)="onTouchStart()"
                                    (touchend)="onTouchEnd($event)" class="template-wrap-container">
                                    <div class='template-wrap'>
                                        <div class="subject">
                                            {{data.Subject}} ({{data.Entities}})
                                        </div>
                                        <div class="sidenote-area" *ngIf="data.notesInThread > 1">
                                            <smart-icon name="side-note"></smart-icon>
                                        </div>
                                        <div class="attachment-area" *ngIf="data.attachmentsInThread > 0">
                                            <smart-icon name="attachment"></smart-icon>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </e-view>
                        <e-view option='Month'>
                            <ng-template #eventTemplate let-data>
                                <div class='template-wrap-month' (dblclick)="onItemDoubleClick($event, data)"
                                    (touchstart)="onTouchStart()" (touchend)="onTouchEnd($event)">
                                    <div class="subject">{{data.Subject}} ({{data.Entities}})</div>
                                    <div class="sidenote-area" *ngIf="data.notesInThread > 1">
                                        <smart-icon name="side-note"></smart-icon>
                                    </div>
                                    <div class="attachment-area" *ngIf="data.attachmentsInThread > 0">
                                        <smart-icon name="attachment"></smart-icon>
                                    </div>
                                </div>
                            </ng-template>
                        </e-view>
                    </e-views>
                </ejs-schedule>
            </div>
            <div *ngIf="isShowGrid" [ngClass]="{'entity-event-grid':isEntity,'all-event-grid':!isEntity}" loading-spin
                [isLoading]="reloading" [loadingSize]="'big'">
                <ag-grid-angular style="width: 100%; height: 100%;-webkit-touch-callout: default;"
                    [gridOptions]="gridOptions" (sortChanged)="onSortChanged($event)"
                    (displayedColumnsChanged)="onDisplayedColumnsChanged($event)"
                    (cellContextMenu)="onContextMenu($event)" (columnVisible)="onColumnVisible($event)"
                    (columnMoved)="onColumnMoved($event)" (columnPinned)="onColumnPinned($event)"
                    (columnResized)="onColumnResized($event)" (bodyScroll)="onBodyScroll($event)"
                    (cellClicked)="onCellClicked($event)" (gridReady)="onGridReady($event)"
                    (contextmenu)="suppressDefaultContextMenu($event)" class="ag-theme-balham"
                    [columnDefs]="columnDefs">
                </ag-grid-angular>
            </div>
            <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
        </ng-template>
    </calendar-layout>
</div>